var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.76607 9.17322c.92777.94118 2.05035 1.66778 3.28893 2.12888l1.6755-1.33333c.0497-.03421.1086-.05252.1689-.05252s.1192.01831.1689.05252l3.1111 2.00443c.1181.071.2181.1685.2921.2848.0739.1163.1198.2482.134.3853.0143.1371-.0036.2756-.0521.4046s-.1263.2449-.2273.3387l-1.4578 1.44c-.2088.2062-.4654.3576-.7469.4406s-.5792.095-.8664.0349c-2.86573-.5919-5.50709-1.978-7.62226-4-2.06823-2.04211-3.49944-4.64051-4.120004-7.47999-.061304-.28283-.048509-.5767.037145-.85313.085654-.27642.241262-.52604.451749-.72465l1.51111-1.457779c.09351-.096095.20755-.169789.33357-.215566.12603-.045776.26078-.062448.39416-.048768.13339.01368.26195.057359.37606.127765s.21082.165715.28287.278791l2.07111 3.071107c.03573.04823.05501.10666.05501.16667 0 .06002-.01928.11844-.05501.16667l-1.36444 1.64c.47359 1.21375 1.21144 2.30685 2.16 3.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.d8186fd5.svg";
export { ForwardRef as ReactComponent };